/**
 * Benchmark Health wordmark for survey header chrome.
 * @agentic members
 */

import { Text } from "@mantine/core";

import styles from "./SurveyWordmark.module.css";

/**
 * Renders the product wordmark in survey layouts.
 * @agentic members
 */
export const SurveyWordmark = () => (
  <Text className={styles.wordmark} component="div">
    Benchmark Health
  </Text>
);
